/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';

import { Loader } from '@components/screen/Layout';
import ModalFull from '@components/modal/ModalFull';
import SociollaText from '@components/sociolla/SociollaText';
import SelectBox from '@components/form/SelectBox';
import BusinessChart from '@/screens/home/components/chart/BusinessChart';
import BusinessLinearChart from '@/screens/home/components/chart/BusinessLinearChart';

import Colors from '@global/colors';
import { prettyNumber } from '@global/helpers';
import { FILTER_PERIOD } from '@/constants';

const BRAND_SORT_BY = [
  { name: 'Highest - Lowest', value: '-target_value' },
  { name: 'Lowest - Highest', value: 'target_value' },
];

const TABS = [
  {
    label: 'MTD',
    value: 'mtd',
  },
  {
    label: 'YTD',
    value: 'ytd',
  },
];

function MobileSalesBrandChart(props) {
  const {
    show = false,
    type = 'mtd',
    loading = false,
    data = [],
    dataTwo = [],
    todayData = {},
    categories = [],
    onChangeType = () => {},
    onSort = () => {},
    onFilter = () => {},
    onClose = () => {},
    filterPeriod = '',
    sort = BRAND_SORT_BY[0],
  } = props;

  return (
    <ModalFull show={show} back title="Sales Brand" onClose={onClose}>
      <ScrollView showsVerticalScrollIndicator={false}>
        <View style={styles.tabs}>
          {TABS.map((item, idx) => (
            <TouchableOpacity
              activeOpacity={0.8}
              style={[
                styles.tabItem,
                type == item.value ? styles.tabItemActive : {},
              ]}
              onPress={() => {
                onChangeType(item.value);
              }}
              key={idx}>
              <SociollaText
                style={[
                  styles.tabItemText,
                  type == item.value ? styles.tabItemTextActive : {},
                ]}>
                {item.label}
              </SociollaText>
            </TouchableOpacity>
          ))}
        </View>
        {loading ? (
          <Loader />
        ) : (
          <>
            <View style={styles.filterChartWrapper}>
              <View style={styles.filterChartItem}>
                <SociollaText style={styles.filterLabel}>Filter</SociollaText>
                <SelectBox
                  label="Filter"
                  hideLabel
                  options={FILTER_PERIOD}
                  value={filterPeriod}
                  placeholder="Select Filter"
                  trackBy="value"
                  labelKey="label"
                  style={styles.filterInput}
                  onChange={(value) => {
                    onFilter(value);
                  }}
                />
              </View>
              {type == 'mtd' ? (
                <View style={styles.filterChartItem}>
                  <SociollaText style={styles.filterLabel}>
                    Sort By
                  </SociollaText>
                  <SelectBox
                    label="Sort By"
                    hideLabel
                    options={BRAND_SORT_BY}
                    value={sort}
                    placeholder="-"
                    trackBy="value"
                    labelKey="name"
                    style={styles.filterInput}
                    onChange={(value) => {
                      onSort(value);
                    }}
                  />
                </View>
              ) : (
                false
              )}
            </View>
            <View style={styles.boxTotal}>
              <View style={styles.boxTotalItem}>
                <SociollaText type="bold" style={styles.boxTotalTitle}>
                  {todayData?.name}
                </SociollaText>
                <View style={styles.boxTotalCompare}>
                  <View style={styles.boxCompareItem}>
                    <View style={styles.labelCat}>
                      {categories.map((item, idx) => (
                        <View style={styles.labelCatRow} key={idx}>
                          <View style={styles.labelCatChild}>
                            <View
                              style={[
                                styles.labelCatBox,
                                { backgroundColor: item.color },
                              ]}
                            />
                            <SociollaText
                              type="medium"
                              style={styles.labelCatText}>
                              {item.label}
                            </SociollaText>
                          </View>
                          <SociollaText
                            type="medium"
                            style={styles.labelCatText}>
                            {' '}
                            :{' '}
                            {prettyNumber(
                              (type == 'ytd'
                                ? todayData?.value
                                : todayData?.[item.key]) || 0,
                            )}
                          </SociollaText>
                        </View>
                      ))}
                    </View>
                  </View>
                  <View style={styles.boxCompareTargetItem}>
                    <SociollaText type="medium" style={styles.targetText}>
                      {prettyNumber(todayData?.percentage || 0)}%
                    </SociollaText>
                  </View>
                </View>
              </View>
            </View>
            <ScrollView
              horizontal
              showsHorizontalScrollIndicator={false}
              contentContainerStyle={type == 'mtd' ? styles.scrollMtd : {}}>
              <View
                style={[
                  styles.chartWrapper,
                  type == 'mtd' ? styles.chartWrapperNormal : {},
                ]}>
                {data?.length || dataTwo?.length ? (
                  <>
                    {type == 'ytd' ? (
                      <BusinessChart data={data} line popup hideCategory />
                    ) : (
                      <BusinessLinearChart
                        data={dataTwo}
                        styleCategory={{
                          position: 'relative',
                          marginTop: 15,
                        }}
                        target={
                          dataTwo?.[
                            sort?.value == '-target_value'
                              ? 0
                              : dataTwo.length - 1
                          ]?.target_value || 0
                        }
                      />
                    )}
                  </>
                ) : (
                  false
                )}
              </View>
            </ScrollView>
          </>
        )}
        {/* {type == 'ytd' ? (
          <View style={styles.chartLabelCat}>
            {categories.map((item, idx) => (
              <View style={styles.chartLabelCatChild} key={idx}>
                <View
                  style={[
                    styles.chartLabelCatBox,
                    { backgroundColor: item.color },
                  ]}
                />
                <SociollaText type="medium" style={styles.chartLabelCatText}>
                  {item.label}
                </SociollaText>
              </View>
            ))}
          </View>
        ) : (
          false
        )} */}
      </ScrollView>
    </ModalFull>
  );
}

const styles = StyleSheet.create({
  tabs: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  tabItem: {
    width: '50%',
    padding: 13,
    textAlign: 'center',
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 2,
  },
  tabItemActive: {
    borderBottomColor: Colors.blue0,
  },
  tabItemText: {
    color: Colors.grey1,
  },
  tabItemTextActive: {
    color: Colors.black0,
  },
  scrollMtd: { width: '100%' },
  filterChartWrapper: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginVertical: 10,
    zIndex: 1,
    elevation: 1,
  },
  filterChartItem: { padding: 10, width: '50%' },
  filterLabel: { fontSize: 12, color: Colors.grey1, marginBottom: 5 },
  filterInput: { width: '100%' },
  boxTotal: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  boxTotalItem: {
    width: '100%',
    maxWidth: 215,
    padding: 15,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: Colors.grey0,
  },
  boxTotalTitle: {
    fontSize: 14,
    color: Colors.black0,
  },
  boxTotalCompare: {
    width: '100%',
    flexDirection: 'row',
    marginTop: 10,
  },
  boxCompareItem: {
    width: '70%',
  },
  boxCompareTargetItem: {
    width: '30%',
    marginTop: -2,
  },
  targetText: {
    fontSize: 15,
    color: Colors.green1,
  },
  labelCat: {
    justifyContent: 'flex-start',
  },
  labelCatRow: { flexDirection: 'row', alignItems: 'center', marginBottom: 10 },
  labelCatChild: { flexDirection: 'row' },
  labelCatBox: { width: 14, height: 14, marginRight: 10 },
  labelCatText: { fontSize: 12 },
  chartWrapper: {
    width: 800,
    paddingLeft: 15,
    marginTop: 15,
    // marginHorizontal: -40,
    // marginBottom: -10,
    // marginTop: -35,
  },
  chartWrapperNormal: {
    width: '100%',
    paddingHorizontal: 15,
    marginTop: 20,
    marginHorizontal: 0,
    marginBottom: 0,
  },
  // chartLabelCat: {
  //   flexDirection: 'row',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   marginBottom: 50,
  // },
  // chartLabelCatChild: { marginHorizontal: 10, flexDirection: 'row' },
  // chartLabelCatBox: { width: 12, height: 12, marginRight: 10 },
  // chartLabelCatText: { fontSize: 10 },
});

export default React.memo(MobileSalesBrandChart, (prev, next) => prev == next);
